export function productUnitMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productUnitId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateProductUnitId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}

export function fixCreateProductUnitId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function fixGetManyProductUnit(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      productUnitId: resource.objectId,
    })),
  };
}

export function productUnitMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, productUnitId: json.result.objectId},
  };
}